import { experience } from '@logto/schemas';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

type SignInNavigation = {
  readonly navigateToSignIn: () => void;
};

export const useSignInNavigation = (): SignInNavigation => {
  const navigate = useNavigate();

  const navigateToSignIn = useCallback(() => {
    navigate(`/${experience.routes.signIn}${window.location.search}`, { replace: true });
  }, [navigate]);

  return { navigateToSignIn };
};
